import cn from 'clsx'

import React from 'react'
import Icon from 'components/ui/icon'
import styles from './index.module.css'

export const TABS_COUNT = 2
export const CHOOSE_PLAN_TAB_IDX = 0
export const ADD_ONS_TAB_IDX = 1
export const PAYMENT_DETAILS_TAB_IDX = 2
type Props = {
  onChange: (...args: Array<any>) => any
  tabIndex: number
}

const PricingMobileTabs = ({
  onChange,
  tabIndex,
}: Props): React.ReactElement<'div'> => {
  const list = ['Choose Plan', 'Add ons', 'Payment details']
  return (
    <div className={styles.pricingMobileTabs}>
      {list.map((text, index) => {
        const active = tabIndex === index
        const pass = tabIndex > index
        return (
          <div
            key={index}
            className={cn(styles.pricingMobileTabsTab, {
              [styles.pricingMobileTabsTabActive]: active,
              [styles.pricingMobileTabsTabPass]: pass,
            })}
            onClick={() => onChange(index)}
          >
            <div className={styles.pricingMobileTabsLine} />
            <div className={styles.pricingMobileTabsTextContainer}>
              <div className={styles.pricingMobileTabsPoint}>
                {pass && <Icon type="check" width={12} height={12} />}
              </div>
              {text}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default PricingMobileTabs
